export default function Contact() {
  return (
    <section id="contact" className="py-32 px-6 bg-gradient-to-b from-zinc-950 to-black">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-6">
            <strong>Book Your Call</strong>
          </h2>
          <p className="text-xl text-gray-400">
            Schedule a call to discuss your options to monetize your audience.
          </p>
        </div>

        {/* Calendly Embed */}
        <div className="bg-zinc-900/50 border border-zinc-800 rounded-lg overflow-hidden min-h-[700px]">
          <iframe
            src="https://calendly.com/matheus-rondinelli-mrprimeops/30min"
            width="100%"
            height="700"
            frameBorder="0"
            title="Schedule a meeting"
          ></iframe>
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500 flex items-center justify-center gap-2">
            <i className="ri-lock-line"></i>
            All bookings and information handled discreetly
          </p>
        </div>
      </div>
    </section>
  );
}
